/** @flow */

import React from "react";
import { localize } from "redux-i18n";
import moment from "moment";
import config from "@config";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Icon,
  Label,
  ComboBox,
} from "@components";
import type { ReferralDecisionTask } from "@modules/shared/reducer/absence-review/types";
type Props = $Exact<{
  ...PropsFromLocalize,
  data: ReferralDecisionTask,
  toggleModal: Function,
}>;

function ReferralDecisionModal(props: Props) {
  const { agreedToReferral } = props.data;

  function generateAcceptedDecision() {
    return props.data.questionAnswers.map((qa, idx) => {
      const { answer, question } = qa;

      if (answer === null) {
        return (
          <Label key={idx} className="small-font-size d-flex">
            {question.questionText}
          </Label>
        );
      }

      const value =
        answer.type === "DATE"
          ? moment(answer.value.toString()).format(config.dateFormat)
          : answer.value;

      return (
        // idx + 1 .... in order to not put bottom margin on the last item
        <div className={idx + 1 !== props.data.questionAnswers.length && "mb-4"} key={question.id}>
          <Label className="small-font-size">{question.questionText}</Label>
          {question.isMandatory && <Icon icon="asterisk" size="xs" className="text-warning ml-2" />}

          {typeof answer.value === "object" &&
          answer.value != null &&
          answer.value.hasOwnProperty("map") ? (
            <ComboBox
              isMulti
              className={answer.type}
              readOnly
              value={answer.value.map(val => {
                return { value: val, label: val };
              })}
            />
          ) : (
            <ComboBox
              readOnly
              value={{ value, label: value }}
              options={[{ value, label: value }]}
            />
          )}
        </div>
      );
    });
  }

  function generateDeclinedDecision() {
    return (
      <ComboBox
        value={{ value: props.data.declineReason?.id, label: props.data.declineReason?.reason }}
        readOnly
        options={props.data.declineReasons.map(reason => {
          return { label: reason.reason, value: reason.id };
        })}
      />
    );
  }

  return (
    <Modal className={"referral-decision-modal modal-normal"}>
      <ModalHeader toggle={props.toggleModal}>
        Activity #{`${props.data.id} - ${props.t(props.data.type)}:`}
      </ModalHeader>
      <ModalBody>
        <p
          dangerouslySetInnerHTML={{
            __html: props.t("REFERRAL_QUESTIONS_LONG_TEXT", {
              SUPPLIER_NAME: props.data.referralSupplier.name,
              SUPPLIER_DESCRIPTION: props.data.referralSupplier.description,
            }),
          }}
        />

        <React.Fragment>
          <ComboBox
            className="mb-4"
            value={{
              value: 1,
              label: props.t(agreedToReferral ? "REFERRAL_ACCEPTED" : "DECLINED_REFERRAL"),
            }}
            options={[
              {
                value: 1,
                label: props.t(agreedToReferral ? "REFERRAL_ACCEPTED" : "DECLINED_REFERRAL"),
              },
            ]}
            readOnly
          />
          {agreedToReferral ? generateAcceptedDecision() : generateDeclinedDecision()}
        </React.Fragment>
      </ModalBody>
      <ModalFooter>
        <Button onClick={props.toggleModal}>{props.t("CLOSE")}</Button>
      </ModalFooter>
    </Modal>
  );
}

export default localize()(ReferralDecisionModal);
